export const VEHICLE_MAKES = {
  Acura: ["ILX", "MDX", "RDX", "TLX", "Integra"],
  Audi: ["A3", "A4", "A6", "Q3", "Q5", "Q7"],
  BMW: ["2 Series", "3 Series", "5 Series", "X1", "X3", "X5"],
  Buick: ["Enclave", "Encore", "Envision"],
  Cadillac: ["CT4", "CT5", "Escalade", "XT4", "XT5"],
  Chevrolet: ["Malibu", "Impala", "Cruze", "Equinox", "Traverse", "Tahoe", "Suburban", "Bolt EV"],
  Chrysler: ["300", "Pacifica", "Voyager"],
  Dodge: ["Charger", "Challenger", "Durango", "Grand Caravan"],
  Ford: ["Fusion", "Focus", "Escape", "Explorer", "Edge", "Expedition", "Mustang Mach-E"],
  GMC: ["Acadia", "Terrain", "Yukon"],
  Honda: ["Accord", "Civic", "CR-V", "Pilot", "HR-V", "Odyssey", "Insight"],
  Hyundai: ["Elantra", "Sonata", "Tucson", "Santa Fe", "Kona", "Ioniq 5", "Palisade"],
  Infiniti: ["Q50", "QX50", "QX60"],
  Jeep: ["Cherokee", "Grand Cherokee", "Compass", "Wrangler", "Renegade"],
  Kia: ["Forte", "Optima", "K5", "Sportage", "Sorento", "Telluride", "Niro", "Soul"],
  Lexus: ["ES", "IS", "RX", "NX", "UX"],
  Lincoln: ["Corsair", "Nautilus", "Aviator"],
  Mazda: ["Mazda3", "Mazda6", "CX-30", "CX-5", "CX-9"],
  "Mercedes-Benz": ["A-Class", "C-Class", "E-Class", "GLA", "GLC", "GLE"],
  Mitsubishi: ["Outlander", "Eclipse Cross", "Mirage"],
  Nissan: ["Altima", "Sentra", "Maxima", "Versa", "Rogue", "Murano", "Pathfinder", "Leaf"],
  Subaru: ["Impreza", "Legacy", "Outback", "Forester", "Crosstrek", "Ascent"],
  Tesla: ["Model 3", "Model Y", "Model S", "Model X"],
  Toyota: ["Corolla", "Camry", "Avalon", "Prius", "RAV4", "Highlander", "Sienna", "4Runner", "Venza"],
  Volkswagen: ["Jetta", "Passat", "Golf", "Tiguan", "Atlas", "ID.4"],
  Volvo: ["S60", "S90", "XC40", "XC60", "XC90"],
  Other: [],
};

export const MAKE_LIST = Object.keys(VEHICLE_MAKES);

const CURRENT_YEAR = new Date().getFullYear();
export const VEHICLE_YEARS = Array.from(
  { length: CURRENT_YEAR - 2010 + 1 },
  (_, i) => String(CURRENT_YEAR - i)
);

export const AIRLINES = [
  "American Airlines", "Delta Air Lines", "United Airlines", "Southwest Airlines",
  "JetBlue", "Frontier Airlines", "Alaska Airlines", "Allegiant Air", "Sun Country",
  "Breeze Airways", "Air Canada", "British Airways", "Lufthansa", "Other",
];

export const DRIVER_AGREEMENT_VERSION = "1.0";
export const DRIVER_AGREEMENT_SECTIONS = [
  { title: "1. Independent Contractor", body: "You are an independent contractor, not an employee of Getaride Orlando. You decide when, where, and how long to drive, and you are responsible for your own taxes and expenses." },
  { title: "2. Eligibility & Documents", body: "You must be at least 21, hold a valid U.S. driver's license, and keep current auto insurance and vehicle registration on file. Your vehicle must be 2010 or newer and pass a basic condition check." },
  { title: "3. Fares & The Marketplace", body: "You may accept the recommended fare or submit a custom fare within the allowed range for each trip request. Riders choose among driver offers. Getaride retains a service fee from each completed fare; the remainder, plus any tips, is yours." },
  { title: "4. Conduct & Safety", body: "You agree to drive safely, obey all traffic laws, never drive under the influence, and treat every rider with respect. Harassment, discrimination, or unsafe driving may result in immediate removal from the platform." },
  { title: "5. Rider Privacy", body: "Rider contact details and pickup locations are provided only to complete a trip. You agree not to contact riders after a trip ends or use their information for any other purpose." },
  { title: "6. Background & Identity Checks", body: "You authorize Getaride to verify your identity, Social Security Number, and driving record, and to re-run these checks periodically while your account is active." },
  { title: "7. Account Approval & Termination", body: "Your application is subject to review and approval before you can go online. Getaride may approve, decline, deactivate, or reinstate your account at its discretion." },
  { title: "8. Liability", body: "You are responsible for your vehicle and for maintaining required insurance. Getaride is a technology platform connecting riders and drivers and is not liable for incidents occurring during trips beyond what applicable law requires." },
];

// helper to read a file as data-url (base64) for photo/doc uploads
export function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
